module.exports = __webpack_public_path__ + "img/step18_a_stand_power_install_stacker_supports.d0ffa168.png";